export default "__VITE_ASSET__CWHjR3RJ__"